// Admin Worker page (E-3 L3 M3; P2-H01). One /worker route with ?section=;
// the sections come from WORKER_WEB_SECTIONS (one file per section, IF-53).
import { Button } from '@heyroot/ui/primitives/Button';
import { EmptyState } from '@heyroot/ui/primitives/EmptyState';
import { useAdminAuth } from '../../lib/auth-context';
import { WORKER_WEB_SECTIONS, type WorkerSectionWeb } from './sections';

export function WorkerPage({
  section,
  onSectionChange,
  sections = WORKER_WEB_SECTIONS,
}: {
  section?: string | undefined;
  onSectionChange: (key: string) => void;
  sections?: readonly WorkerSectionWeb[];
}) {
  const { hasPerm } = useAdminAuth();
  const visible = sections.filter((s) => hasPerm(s.perm));
  const active = visible.find((s) => s.key === section) ?? visible[0];

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-heading-2 text-primary">Worker</h1>
        <p className="mt-1 text-body-sm text-muted">
          Schedules, dead jobs, kind state, alerts, findings, queues and fire drills for the
          root-worker queue. Payloads are never shown.
        </p>
      </div>

      {visible.length === 0 || !active ? (
        <EmptyState title="No Worker sections are available to your role" />
      ) : (
        <>
          <div
            className="flex items-center gap-2 flex-wrap"
            role="group"
            aria-label="Worker sections"
          >
            {visible.map((s) => (
              <Button
                key={s.key}
                size="sm"
                variant={s.key === active.key ? 'emphasis' : 'secondary'}
                aria-pressed={s.key === active.key}
                onClick={() => onSectionChange(s.key)}
              >
                {s.label}
              </Button>
            ))}
          </div>
          <active.Component />
        </>
      )}
    </div>
  );
}
